import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { InfoPopoverComponent } from 'app/shared/components/info-popover/info-popover.component';

@Component({
  selector: 'ez-payment-method-selection-element',
  imports: [ReactiveFormsModule, InfoPopoverComponent],
  templateUrl: './payment-method-selection-element.component.html',
  styleUrl: './payment-method-selection-element.component.scss',
})
export class PaymentMethodSelectionElementComponent implements OnInit {
  private rootFormGroup = inject(FormGroupDirective);

  @Input({ required: true }) controlName: string;
  @Input({ required: true }) value: string;
  @Input({ required: true }) label: string;
  @Input({ required: true }) iconSrc: string;
  @Input({ required: true }) popoverText: string;
  form: FormGroup;

  ngOnInit(): void {
    this.form = this.rootFormGroup.control;
  }
}
